import { render } from "./Keyboard.vue?vue&type=template&id=2197595c&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"

import "./Keyboard.vue?vue&type=style&index=0&id=2197595c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2197595c"]])

export default __exports__